import { combineReducers } from 'redux';
import auth from './authReducer';
import {
  friends,
  mindfile,
  mindfiles,
  viewItem,
  isCurrentMindfileOwner,
  isCurrentMindfileContributor,
  folderList,
  folders,
  folderDetails,
  mindfile_items,
  itemLocations,
  spacecastSettings,
  multiUserMindfiles,
  userViewOpts, selectedItems, selectedFolders, usageData, mindfileUserLevel, importSources,
} from './getDataReducer';

import { mindfileFilterValues } from '../actions/getFilterDataActions';
import { rssNews } from '../actions/getRssNewsActions';
import {surveyGroups} from '../actions/surveyActions';
import {helpData, helpEdits} from "../actions/helpActions";

const reducers = {
  auth,
  mindfile,
  mindfiles,
  friends,
  viewItem,
  isCurrentMindfileOwner,
  isCurrentMindfileContributor,
  mindfileUserLevel,
  folderList,
  folders,
  selectedFolders,
  folderDetails,
  mindfile_items,
  selectedItems,
  itemLocations,
  spacecastSettings,
  multiUserMindfiles,
  mindfileFilterValues,
  userViewOpts,
  usageData,
  rssNews,
  importSources,
  surveyGroups,
  helpEdits,
  helpData
}

const rootReducer = combineReducers(reducers);

export default rootReducer;
